module.exports = __webpack_public_path__ + "media/images/official/plancheck_kv-89199168d762680abd5afeeadfbc9be9.svg";